<template>
  <el-dialog title="新增鱼塘"  :visible.sync="dialogFormVisible"  width="766px" @close="close">
    <el-form :model="ruleForms" :rules="rules" ref="ruleFormsRef" label-width="80px">
      <el-form-item label="所在基地" prop="fishBaseId">
        <el-select v-model="ruleForms.fishBaseId" filterable placeholder="请选择所在基地" @change="chooseFishBase">
          <el-option v-for="item in baseList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="塘口编号" prop="no">
        <el-input v-model="ruleForms.no" placeholder="请输入塘口编号" type="text"></el-input>
      </el-form-item>
      <el-row>
        <el-form-item label="主养品种" required>
          <el-col :span="9">
            <el-form-item prop="fishCategoryId" class="fisherr">
              <el-select v-model="ruleForms.fishCategoryId" filterable  class="fishType" placeholder="请选择鱼分类名称" @change="changeFishGetCategory">
                <el-option v-for="item in fishGetCategory" :key="item.key" :label="item.value" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9" v-if="ruleForms.fishCategoryId" >
            <el-form-item prop="fishName" >
              <el-select v-model="ruleForms.fishId" filterable class="fishName" placeholder="请选择鱼种类型" @change="getFishName">
                <el-option v-for="item in fishGetCategoryName" :key="item.key" :label="item.value" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="养殖类型" required class="fisherr">
          <el-col :span="9">
            <el-form-item prop="cultivationTypeId">
              <el-select v-model="ruleForms.cultivationTypeId" filterable  class="fishType" placeholder="请选择养殖类型">
                <el-option v-for="item in cultureTypeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item prop="fishTypeId" class="fisherr">
              <el-select v-model="ruleForms.fishTypeId" filterable  class="fishName" placeholder="请选择渔种类型">
                <el-option v-for="item in fishTypeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-row>
      <el-form-item label="养殖模式" prop="modeId">
        <el-select v-model="ruleForms.modeId" filterable  placeholder="请选择养殖模式" >
          <el-option v-for="item in cultureModeList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="塘口面积" prop="area">
        <el-input v-model="ruleForms.area" placeholder="请输入面积"  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
          <i slot="suffix" style="font-style:normal">亩</i>
        </el-input>
      </el-form-item>
      <el-form-item label="平均水深" prop="avgDeep">
        <el-input v-model="ruleForms.avgDeep" placeholder="请输入水深" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
          <i slot="suffix" style="font-style:normal">米</i>
        </el-input>
      </el-form-item>
      <el-form-item label="负责人" prop="leaderId">
        <el-select v-model="ruleForms.leaderId" filterable placeholder="请选择负责人" >
          <el-option v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close()" >取 消</el-button>
      <el-button type="primary" @click="save()" :loading="loading">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
export default {
  data () {
    return {
      ruleForms: {},
      baseList: [],
      cultureTypeList: [],
      fishTypeList: [],
      cultureModeList: [],
      companyUser: [],
      dialogFormVisible: false,
      loading: false,
      rules: {
        fishBaseId: [{ required: true, message: "请输入所在基地", trigger: "blur" }],
        no: [{ required: true, message: "请输入塘口编号", trigger: "blur" }],
        fishCategoryId: [{ required: true, message: "请选择鱼分类名称", trigger: "change" }],
        fishId: [{ required: true, message: "请选择鱼种名称", trigger: "change" }],
        cultivationTypeId: [{ required: true, message: "请选择养殖类型", trigger: "change" }],
        fishTypeId: [{ required: true, message: "请选择渔种类型", trigger: "change" }],
        modeId: [{ required: true, message: "请选择养殖模式", trigger: "change" }],
        area: [
          { required: true, message: "请输入塘口面积", trigger: "blur" },
          { pattern: /^[0-9]{1,6}([.][0-9]{1,2})?$/, message: "塘口面积格式不对,请重新输入" }
        ],
        avgDeep: [
          { required: true, message: "请输入平均水深", trigger: "blur" },
          { pattern: /^[0-9]{1,4}([.][0-9]{1,2})?$/, message: "平均水深格式不对,请重新输入" }
        ],
        leaderId: [{ required: true, message: "请选择塘口负责人", trigger: "change" }]
      },
    }
  },
  computed: {
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
  },
  methods: {
    ...mapActions(modules.pond, ["addPondSettingList"]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.user, ["getEmployeesByFishBase"]),
    ...mapActions(modules.dataDict, [
      "getCultureType", //养殖类型
      "getFishType", //渔种类型
      "getCultureMode" //养殖模式
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory", // 获取渔种信息
      "getFishGetCategoryName" // 获取分类渔种名称
    ]),
    async initParameter(){
      await this.getBaseList()
      await this.getFishGetCategory()
      await this.getCultureTypeFn()
      await this.getFishTypeFn()
      await this.getCultureModeFn()
      await this.getEmployeesByFishBaseFn()
    },
    // 选择基地回调函数
    chooseFishBase(){

    },
    // 选择鱼分类回调函数
    changeFishGetCategory(fishCategoryId){
      this.ruleForms.fishId = "";
      this.ruleForms.fishName = "";
      this.ruleForms.fishCategoryName = this.fishGetCategory.find( item => item.key === fishCategoryId).value
      this.getFishGetCategoryName(this.ruleForms.fishCategoryId)
    },
    // 选择鱼类型回调函数
    getFishName(fishId){
      this.ruleForms.fishName = this.fishGetCategoryName.find( item => item.key === fishId).value
      this.$forceUpdate()
    },
    add(){
      this.ruleForms = {}
      this.dialogFormVisible = true
      if(this.baseList.length) this.ruleForms.fishBaseId = this.baseList[0].key
    },
    async save(){
      this.loading = true
      const validateRes = await this.$refs.ruleFormsRef.validate().catch(err => err)
      if(!validateRes) return this.loading = false
      let res = await this.addPondSettingList(this.ruleForms).catch( err => {
        this.$Alert.info({
          content: err.response.data,
          duration: 5000,
          status: "error"
        });
      })
      this.loading = false
      if(!res) return
      this.$message.success('保存成功');
      this.$emit('getPongAllView')
      this.close()
    },
    close() {
      this.dialogFormVisible = false;
      this.$refs.ruleFormsRef.resetFields();
    },
    // 获取基地列表
    async getBaseList(){
      this.baseList = await this.getAllBaseList()
      this.ruleForms.fishBaseId = this.baseList[0].key
    },
    // 获取养殖类型列表
    async getCultureTypeFn(){
      this.cultureTypeList = await this.getCultureType();
    },
    // 获取鱼种类型列表
    async getFishTypeFn(){
      this.fishTypeList = await this.getFishType();
    },
    // 获取鱼种类型列表
    async getCultureModeFn(){
      this.cultureModeList = await this.getCultureMode(); //养殖模式
    },
    // 获取负责人列表
    async getEmployeesByFishBaseFn(){
      this.companyUser = await this.getEmployeesByFishBase(this.ruleForms.fishBaseId)
    },
  },
  mounted() {
    this.initParameter()
  },
}
</script>

<style lang="stylus" scoped>
  
</style>